import { render, staticRenderFns } from "./friendsfission.vue?vue&type=template&id=535193a2&scoped=true"
import script from "./friendsfission.vue?vue&type=script&lang=js"
export * from "./friendsfission.vue?vue&type=script&lang=js"
import style0 from "./friendsfission.vue?vue&type=style&index=0&id=535193a2&prod&lang=less&scoped=true"
import style1 from "./friendsfission.vue?vue&type=style&index=1&id=535193a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535193a2",
  null
  
)

export default component.exports